import { ReactComponent as BestPhotoIcon } from 'img/quota-landing/aiTariff/stars_20.svg';
import React, { memo, useState } from 'react';
import { getBestPhotoViewerTooltipShown } from 'reactApp/modules/duplicates/duplicates.helpers';
import { BestPhotoViewerTooltip } from 'reactApp/ui/Duplicates/BestPhotoTooltip/BestPhotoViewerTooltip';

import styles from './DuplicatesToolbar.css';

interface Props {
    position: number;
    groupLength: number;
    isBest?: boolean;
}

export const DuplicatesToolbar = memo(function DuplicatesToolbar({ position, groupLength, isBest }: Props): JSX.Element {
    const [target, setTarget] = useState<HTMLDivElement | null>(null);

    const isShowTooltip = isBest && !getBestPhotoViewerTooltipShown() && target;

    return (
        <div className={styles.root} data-qa-id="duplicates-viewer-toolbar">
            {isShowTooltip && <BestPhotoViewerTooltip target={target} />}
            <div className={styles.wrapper}>
                {isBest && (
                    <div className={styles.leftBlock} ref={setTarget}>
                        <BestPhotoIcon className={styles.icon} data-qa-id="duplicates-viewer-icon" />
                        <div className={styles.separator} />
                    </div>
                )}
                <div className={styles.rightBlock} data-qa-id="duplicates-viewer-counter">
                    <span data-qa-id="duplicates-viewer-position">{position}</span> из{' '}
                    <span data-qa-id="duplicates-viewer-group-length">{groupLength}</span>
                </div>
            </div>
        </div>
    );
});
